import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import Validator from '@opsbase/lib-validator';
import useStaffChangeEmail from '@opsbase/react-gql-hooks/staff/useStaffChangeEmail';
import useStaffFindById from '@opsbase/react-gql-hooks/staff/useStaffFindById';
import ConfirmDialog from '@opsbase/web-dialogs/ConfirmDialog';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions/useNotificationActions';
import TextFieldWithEmail from '@opsbase/web-textfield/TextFieldWithEmails/TextFieldWithEmail';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useState } from 'react';
export function StaffChangeEmailDialog() {
    const { id } = useParams();
    const { loading, data } = useStaffFindById({ variables: { id } });
    const [email, setEmail] = useState('');
    const { raise } = useNotificationActions();
    const changeStaffEmail = useStaffChangeEmail();
    const valid = Validator.isValid({ email });
    const handleAction = useCallback(async () => raise(changeStaffEmail({ id, email }), i18n.t('user-emailchanged-successful')), [changeStaffEmail, email, id, raise]);
    return (React.createElement(ConfirmDialog, { onConfirm: handleAction, agreeText: i18n.t('change-email'), notAgreeText: i18n.t('cancel'), color: Palette.secondary, canConfirm: !!valid, loading: loading }, !loading && !!data && (React.createElement(React.Fragment, null,
        React.createElement(Text, null, i18n.t('confirm-user-change-email')),
        React.createElement(TextFieldWithEmail, { placeholder: i18n.t('enter-new-email'), helperText: `Current email ${data === null || data === void 0 ? void 0 : data.email}`, value: email, onChange: setEmail, fullWidth: true })))));
}
export default StaffChangeEmailDialog;
